import { css } from "@emotion/core";

export const breadcrumbMixin = css`
  .breadcrumb {
    margin-bottom: 0;
  }
`;
